// services/accessLevels.js
export const accessLevels = {
    user: 'user',
    application: 'application',
    levels: 'levels',
    dishes: 'dishes',
    notes: 'notes',
    ads: 'ads',
    meetings: 'meetings',
    gamifications: 'gamifications',
    chats: 'chats',
    posts: 'posts',
    cms_www: 'cms_www',
    groups: 'groups',
    files: 'files',
    sso: 'sso',
    libraries: 'libraries',
    galleries: 'galleries',
    banners: 'banners',
    forms: 'forms',
    polls: 'polls',
    recipes: 'recipes',
    promotions: 'promotions',
    newspapers: 'newspapers',
    evaluations: 'evaluations',
    level_rebuses: 'level_rebuses',
    rebuses: 'rebuses',
    coupons: 'coupons',
    price_lists: 'price_lists',
    users_www: 'users_www',
    shopping_lists: 'shopping_lists',
    short_codes: 'short_codes',
    themes: 'themes',
    data_management_users: 'data_management_users',
    superuser: 'superuser',
    public: 'public'
};
